<template>
  <div class="container">
      <button class="btn btn-danger float-end" @click.prevent="showCreateVariable()">Crear nueva variable general</button>
    <div class="container w-75 table-responsive ms-5 me-5">
      <table class="table">
        <tbody>
          <tr>
            <th>Nombre</th>
            <th>Valor</th>
          </tr>
          <tr v-for="variable in variables" :key="variable.id">
            <td>{{ variable.name }}</td>
            <td>{{ variable.value }} %</td>
            <td><button class="btn btn-danger" @click.prevent="editVariable(variable.id)">Editar</button></td>
          </tr>
        </tbody>
      </table>
    </div>
    <RegisterVariable v-show="showPopUp" @hidePopUp="hideCreateVariable"></RegisterVariable>
  </div>
</template>
<script>
import axios from "axios";
export const RUTA_SERVIDOR = process.env.VUE_APP_RUTA_BACKEND;
import RegisterVariable from "@/components/Admin/Constants/RegisterVariableAdminComponent.vue"
export default {
  data() {
    return {
      variables: [],
      showPopUp: false,
    };
  },
  components: {
    RegisterVariable,
  },
  beforeMount() {
    this.loadVariables();
  },
  methods: {
    editVariable(variableId) {
      this.$emit("sendVariableId", variableId)
    },
    showCreateVariable() {
      this.showPopUp = true;
    },
    hideCreateVariable(data) {
      this.showPopUp = data;
    },
    loadVariables() {
      axios
        .get(RUTA_SERVIDOR + "api/variable/list", {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        })
        .then((res) => (this.variables = res.data))
        .catch((err) => console.log(`There has been an error ${err}`));
    },
  },
};
</script>